import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MxInfoTooltipModule, MxMaterialModule, MxSharedModule} from 'mx-core';

@NgModule({
    imports: [
        MxMaterialModule,
        MxInfoTooltipModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MxSharedModule
    ],
    exports: [
        CommonModule,
        MxMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        MxSharedModule
    ]
})
export class SharedModule { }
